import React, {useState} from 'react';
import {
  Checkbox,
  makeStyles,
} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  searchInput: {
    'backgroundColor': 'transparent !important',
    'marginBottom': '15px',
    'padding': 0,
    '& .MuiInputBase-input': {
      height: '0.6rem',
    },
  },
  customTable: {
    backgroundColor: '#32046926',
    padding: '0 !important',
  },
  clearIcon: {
    paddingTop: 6,
    fontSize: '1.5rem !important',
    color: '#707070',
    cursor: 'pointer',
  },
  searchIcon: {
    fontSize: '1.5rem !important',
    paddingBottom: 5,
  },
  selectLabel: {
    justifyContent: ' flex-end !important',
    whiteSpace: 'pre',
  },
  colHeader: {
    borderBottom: '2px solid #ffffff !important',
  },
}));
const CopyAddressTable = ({copyAddressTableData, setCopyAddressTableData}) => {
  const classes = useStyles();
  const [selectAll, setSelectAll] = useState({
    copyParentAddress: false,
    copyParentContacts: false,
  });
  const handleChange = (e, i, field, selectAllField) => {
    const arr = [...copyAddressTableData];
    arr[i][field] = e.target.checked;
    const isAllContactsSel = Object.keys(arr.filter((each) => each.parentContact === true)).length === Object.keys(arr.map((each) => each.parentContact)).length;
    const isAllAddressSel = Object.keys(arr.filter((each) => each.parentAddress === true)).length === Object.keys(arr.map((each) => each.parentAddress)).length;
    const obj = {copyParentAddress: isAllAddressSel, copyParentContacts: isAllContactsSel};
    setSelectAll(obj);
    setCopyAddressTableData(arr);
  };

  const handleSelectAllCheckbox = (e, field, clildField) => {
    const arr = [...copyAddressTableData].map((data) => {
      const obj = data;
      obj[clildField] = e.target.checked;
      return obj;
    });

    const selectAllData = {...selectAll};
    selectAllData[field] = e.target.checked;

    setCopyAddressTableData(arr);
    setSelectAll(selectAllData);
  };
  return (
    <div className={`mui-custom-table-container custom-mui-table copy-address-table ${classes.customTable}`}>
      <table>
        <thead>
          <tr>
            <td>Client Code</td>
            <td>
              <Checkbox
                checked={selectAll.copyParentAddress}
                onChange={(e) => {
                  handleSelectAllCheckbox(e, 'copyParentAddress', 'parentAddress');
                }}
                inputProps={{'aria-label': 'primary checkbox'}}
              />
              Copy Parent Address
            </td>
            <td>
              <Checkbox
                checked={selectAll.copyParentContacts}
                onChange={(e) => {
                  handleSelectAllCheckbox(e, 'copyParentContacts', 'parentContact');
                }}
                inputProps={{'aria-label': 'primary checkbox'}}
              />
              Copy Parent Contacts
            </td>
          </tr>
        </thead>
        <tbody>
          {copyAddressTableData.map((row, i) => {
            return (
              <tr key={i}>
                <td>{row.clientCode}</td>
                <td>
                  <Checkbox
                    checked={row.parentAddress}
                    onChange={(e) => {
                      handleChange(e, i, 'parentAddress', 'copyParentAddress');
                    }}
                    inputProps={{'aria-label': 'primary checkbox'}}
                  />
                </td>
                <td>
                  <Checkbox
                    checked={row.parentContact}
                    onChange={(e) => {
                      handleChange(e, i, 'parentContact', 'copyParentContacts');
                    }}
                    inputProps={{'aria-label': 'primary checkbox'}}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CopyAddressTable;
